import { RewardInfoPc } from './RewardInfo/RewardInfo.pc';
import { RewardInfoMobile } from './RewardInfo/RewardInfo.mobile';
import { useIsMobile } from '../../../hook/useIsMobile';

export const RewardInfo = () => {
  const isMobile = useIsMobile();
  return isMobile ? <RewardInfoMobile /> : <RewardInfoPc />;
};
